import variables from '@/assets/styles/element-variables.scss'

const state = {
	theme: variables.theme,
	showSettings: false,
	//获取本地值虽然没得引号，但也是字符串
	tagsViewShow: window.localStorage.getItem("tagsViewShow") == "true" ? true : false,
	fixedHeader: false,
	sidebarLogo: true
}
const getters = {
	theme: state => state.theme,
	tagsViewShow: state => state.tagsViewShow
}

const mutations = {
	CHANGE_SETTING: (state, {
		key,
		value
	}) => {
		if (state.hasOwnProperty(key)) {
			state[key] = value
		}
	},
	CHANGE_TAGSVIEW: (state, val) => {
		state.tagsViewShow = val
		window.localStorage.setItem('tagsViewShow', val)
	},
}

const actions = {
	changeSetting({
		commit
	}, data) {
		commit('CHANGE_SETTING', data)
	},
	changeTagsView({
		commit
	}, data) {
		commit('CHANGE_TAGSVIEW', data)
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
